fragment CoordinatesFragment on Coordinates {
    latitude
    longitude
    accuracy
}
